import { com } from '@eidu/form'
import PermittedActions = com.eidu.sharedlib.entity.permission.PermittedActions
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import entityApiUrl from '../baseUrl'
import requireAuthContext from '../../authorization/requireAuthContext'

export type GetPermittedActionsParameters = {
  requested: PermittedActions
}

const getPermittedActions = async ({ requested }: GetPermittedActionsParameters): Promise<PermittedActions> => {
  const authContext = await requireAuthContext()
  return fetch(
    `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/user/${authContext.userEntityId}/get-permitted-actions`,
    {
      headers: {
        Authorization: `Bearer ${authContext.accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(requested),
      method: 'POST',
    }
  ).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from getUserPermissions endpoint`)
    return PermittedActions.fromJsonString(await response.text())
  })
}

export default getPermittedActions
